import React from 'react';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

function StarRating(props) {

    return (
        <div style={{display: 'flex'}}>

            {[1, 2, 3, 4, 5].map((index) => (
                <span
                    key={index}
                    onMouseEnter={() => props.onChange && props.onChange(index)}
                    onClick={() => props.onChange && props.onChange(index)}
                    style={{cursor: 'pointer'}}
                >
                    {index <= props.starRatingValue ? <StarIcon style={{color: '#f9a825'}} fontSize="small"/> :
                        <StarBorderIcon style={{fill: '#f9a825'}} fontSize="small"/>}
                </span>
            ))}
        </div>
    );
}

export default StarRating;
